import "./button.style.scss";
const BtnGetStarted = () => {
  return <div className="btn-get-started">Let’s Go</div>;
};

export default BtnGetStarted;
